import React, { useCallback, useContext } from 'react';
import PricingContext from '../../../context/pricing';
import { resetPackage } from '../../../actions/pricing';
import withSelections from '../withSelections';
import StyledCart from './styles';
import Tooltip from '../Tooltip';
import Theme from '../../Theme';
import XIcon from '../../SVG/XIcon';

const { scaleDown03 } = Theme.scale;

const Cart = (props) => {
  const { dispatch } = useContext(PricingContext);
  const { addons, easeAdded, ipAdded, eiPackage, mcPackage } = props;

  // We only show the addons if the addons prop is true and there is at least one addon in the cart.
  const showAddons = addons && (ipAdded || easeAdded);

  const getTotal = useCallback(() => {
    let total = 0;
    if (eiPackage) total += eiPackage.rate;
    if (mcPackage) total += mcPackage.rate;
    if (easeAdded) total += eiPackage.ease;
    if (ipAdded) total += 30;
    return total.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }, [eiPackage, mcPackage, ipAdded, easeAdded]);

  const getAddonCopy = useCallback(() => {
    const addonCopy = [
      ...(ipAdded ? ['1 Additional Dedicated IP Address'] : []),
      ...(easeAdded ? ['30 Days of Email Activity History'] : []),
    ];

    const addonJSX = addonCopy.map((addon, index) =>
      index ? (
        <Tooltip key={addon} tip={addon}>
          {' '}
          + 1 more
        </Tooltip>
      ) : (
        <span key={addon} className={`addon-${index}`}>
          {addon}
        </span>
      )
    );

    return addonJSX;
  }, [ipAdded, easeAdded]);

  return (
    <StyledCart>
      <div className="cart-items" data-testid="cart">
        <div className="plans">
          <div className="plans-label">
            {addons && <span>Selected </span>}
            {eiPackage && mcPackage ? 'Plans' : 'Plan'}
          </div>
          <div className="plans-packages">
            {mcPackage && (
              <div data-testid="mc-package">
                Marketing Campaigns: {mcPackage.name}
                {!addons && (
                  <button
                    type="button"
                    className="remove-package"
                    onClick={() => resetPackage('mc', dispatch)}
                  >
                    <XIcon title="Remove" size={scaleDown03} />
                  </button>
                )}
              </div>
            )}

            {eiPackage && (
              <div data-testid="ei-package">
                Email API: {eiPackage.name}
                {!addons && (
                  <button
                    type="button"
                    className="remove-package"
                    onClick={() => resetPackage('e', dispatch)}
                  >
                    <XIcon title="Remove" size={scaleDown03} />
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
        {showAddons ? (
          <div className="addons">
            <div className="addons-label">Add-on(s)</div>
            <div className="addons-packages">{getAddonCopy()}</div>
          </div>
        ) : null}
      </div>
      <div className="total">
        <span>Future estimated monthly cost:</span>
        <strong data-testid="total">${getTotal()}*</strong>
        <small>*Taxes and overages may apply.</small>
      </div>
    </StyledCart>
  );
};

export default withSelections(Cart);
